<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />

    <form @keydown.enter.prevent="submit()">
      <!-- data provider  -->
      <div>
        <!-- title  -->
        <h2 class="mb-1" style="display: flex;">{{ $t('Įgaliojimo asmenys') }}<el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Įgaliojimo asmenys" title></el-tooltip></h2>
        <h3 class="mb-1 pt-2" style="display: flex;">{{ $t('Dokumento sudarytojas') }}<el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Dokumento sudarytojas" subTitle></el-tooltip></h3>
        <div>
      <!-- add person btn -->
      <v-row>
      <v-col cols="12" sm="4" class="mr-5">
        <el-button
          v-if="showAddPersonPrincipalsBtn && showAddPersonRepresentitivesBtn"
          small
          class="mb-2"
          color="primary"
          icon="pridėti"
          title="Pridėti mane prie įgaliotojų"
          :loading="loading"
          @click.native.stop="AddPersonBtn(false)"
        />
      </v-col>
       <v-col  cols="12" sm="6">
        <el-button
          v-if="showAddPersonRepresentitivesBtn && showAddPersonPrincipalsBtn"
          small
          class="mb-2"
          color="primary"
          icon="pridėti"
          title="Pridėti mane prie įgaliotinių"
          :loading="loading"
          @click.native.stop="AddPersonBtn(true)"
        />
      </v-col>
      </v-row>
      </div>
        <v-card outlined>
          <!-- form  -->
          <v-card-text class="pa-0">
            <v-row class="mb-0 pb-0">
              <v-col class="pb-0" cols="12" md="12">
                <el-simple-table :items="documentDataList" />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
   
      <!-- principals  -->
      <div class="pt-3">
        <!-- title  -->
        <h3 class="mb-1" style="display: flex;">{{ $t('Įgaliotojai') }}<el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Įgaliotojai" subTitle></el-tooltip></h3>
        <!-- add button  -->
        <el-button
          v-if="canAddPrincipal"
          class="mb-3"
          small
          color="primary"
          icon="pridėti"
          title="Pridėti įgaliotoją"
          :loading="loading"
          @click.native.stop="newPrincipal()"
        />
        <h4 v-if="showPrincipalsTableText">{{$t('Įgaliotojai ar įgaliotojų atstovai pasirašo sąraše nurodytu eiliškumu.')}}</h4>
        <h4 v-if="showPrincipalsTableText" style="color:red">{{$t('Paskutinis sąraše esantis įgaliotojas ar įgaliotojo atstovas apmoka už įgaliojimo įregistravimą.')}}</h4>
        <v-data-table
          v-if="showPrincipalsTable"
          class="mb-4 custom-table"
          :loading="loading"
          :headers="headersPrincipals"
          :items-per-page="1000"
          :items="formData.principals"
          :hide-default-footer="true"
          :header-props="{
            sortByText: $t('Rūšiuoti pagal')
          }"
        >
        <!-- custom templates -->
        <template v-slot:item="{ item, index }">
          <tr>
            <td class="pr-0 pl-2">{{ formatedIndex(index)  }}</td>
            <td>{{ item.code || item.iltu_code }}</td>
            <td>{{ item.fullname }}</td>
            <td>{{ item.other_info }}</td>
            <td>
              <template>
                <div class="nowrap">
                  <el-table-action
                    :item="setEditPrincipals(item)"
                    @deleteItem="deleteItem({ item, type: 'principals' })"
                    @addJurRepresenterItem="newJurRepresenter(item)"
                  />
                </div>
              </template>
            </td>
          </tr>
        </template>
        </v-data-table>
        <!--  -->
        <div v-if="subMandate && showDeletedItemList" class="pt-3">
          <h4 >{{$t('Pašalinti įgaliotojai ')}}</h4>
         <v-data-table
          class="mb-4 custom-table"
          :loading="loading"
          :headers="headersPrincipals"
          :items="getDeletedItems"
          :hide-default-footer="true"
          :items-per-page="1000"
           :item-class="rowClass"
          :header-props="{
            sortByText: $t('Rūšiuoti pagal')
          }"
        >
          <template #[`item.actions`]="{ item }">
            <div class="nowrap">
              <el-table-action
                :item="setSubMandateDeletedParams(item)"
               @addCustomItem="addServiceSubMandate"
              />
            </div>
          </template>
        </v-data-table>
      </div>
        <!--  -->
        <el-radio-group
          class="mt-0"
          inline
          :disabled="lockPrincipalsTogether"
          v-if="showOperationPrincipalsType"
          v-model="formData.principals_together"
          :items="togetherList"
          required
        >
        </el-radio-group>
      </div>
   
      <!-- representitives  -->
      <div v-if="!subMandate" class="pt-4">
        <!-- title  -->
        <h3 class="mb-1" style="display: flex;">{{ $t('Įgaliotiniai') }}<el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Įgaliotiniai" subTitle></el-tooltip></h3>
        <!-- add button  -->
        <el-button
          v-if="canAddRepresentitive"
          small
          class="mb-3"
          color="primary"
          icon="pridėti"
          title="Pridėti įgaliotinį"
          :loading="loading"
          @click.native.stop="newRepresentative()"
        />
        <v-data-table
          v-if="showRepresentitivesTable"
          class="mb-4 custom-table"
          :loading="loading"
          :headers="headers"
          :items="formData.representitives"
          :hide-default-footer="true"
          :items-per-page="1000"
          :header-props="{
            sortByText: $t('Rūšiuoti pagal')
          }"
        >
          <template #[`item.index_number`]="{ item, index }">
            <td class="pr-0 pl-2">{{ formatedRepresentitivesIndex(index)  }}</td>
          </template>
          <template #[`item.code`]="{ item }">
            {{ item.code || item.iltu_code }}
          </template>
          <template #[`item.actions`]="{ item, index }">
            <div class="nowrap">
              <el-table-action
                :item="setRepresentitivesParams(item, 'representitives', index)"
                @deleteItem="deleteItem({ item, type: 'representitives' })"
              />
            </div>
          </template>
        </v-data-table>
        <el-radio-group
          class="mt-0"
          inline
          v-if="showOperationRepresentitivesType"
          v-model="formData.representitives_together"
          :items="togetherList"
          required
        >
        </el-radio-group>
      </div>
      <!-- sub_representitives  -->
      <div v-if="subMandate" class="pt-4">
        <!-- title  -->
        <h3 class="mb-1" style="display: flex;">{{ $t('Perįgaliotiniai') }}<el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Perįgaliotiniai" subTitle></el-tooltip></h3>
        <!-- add button  -->
        <el-button
          v-if="canAddSubRepresentitive"
          small
          class="mb-3"
          color="primary"
          icon="pridėti"
          title="Pridėti perįgaliotinį"
          :loading="loading"
          @click.native.stop="newSubRepresentative()"
        />
        <v-data-table
          v-if="showSubRepresentitivesTable"
          class="mb-4 custom-table"
          :loading="loading"
          :headers="headers"
          :items="formData.sub_representitives"
          :hide-default-footer="true"
          :items-per-page="1000"
          :header-props="{
            sortByText: $t('Rūšiuoti pagal')
          }"
        >
        <template #[`item.index_number`]="{ item, index }">
          <td class="pr-0 pl-2">{{ formatedSubRepresentitivesIndex(index)  }}</td>
          </template>
          <template #[`item.code`]="{ item }">
            {{ item.code || item.iltu_code }}
          </template>
          <template #[`item.actions`]="{ item }">
            <div class="nowrap">
              <el-table-action
                :item="setEdit(item, 'sub_representitives')"
                @deleteItem="deleteItem({ item, type: 'sub_representitives' })"
              />
            </div>
          </template>
        </v-data-table>
        <el-radio-group
          class="mt-0"
          inline
          v-if="showOperationSubRepresentitivesType"
          v-model="formData.sub_representitives_together"
          :items="togetherList"
          required
        >
        </el-radio-group>
      </div>
      <!-- actions  -->
      <v-card-actions>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <el-button
            class="mr-1"
            color="secondary"
            icon="atgal"
            title="Atgal"
            @click.native.stop="back()"
            :loading="loading"
          />
          <el-button
            v-if="!modeReadonly"
            title="Tęsti"
            :loading="loading"
            @click.native="next()"
            color="primary"
            icon="pirmyn"
          />
        </v-row>
      </v-card-actions>
      <!-- modal  -->
      <modal-add-person
        v-if="showAddPerson"
        v-model="showAddPerson"
        :modalType="modalType"
        :additionalData="formData"
        @addPersonData="addPerson"
        mandate
      />
      <modal-delete
        title="Įrašo šalinimas"
        :text="`Ar tikrai norite pašalinti?`"
        :code="getModalDeleteCode"
        v-model="showDelete"
        :item="modalDeleteItem"
        @confirmDelete="confirmDelete"
      />
    </form>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import unsavedData from '@/mixins/unsavedData'
import ModalAddPerson from '@/components/modals/ModalAddPerson'
import ModalDelete from '@/components/modals/ModalDelete'
import Enums from '@/enums'
import InJournalStatus from '@/components/constants/inJournalStatus'

export default {
  name: 'MandateStep2',
  components: {
    ModalAddPerson,
    ModalDelete,
  },
  mixins: [userRole, unsavedData],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      showAddPerson: false,
      loading: false,
      formData: {
        data_provider: {},
        data_provider_representitive: {},
      },
      modalType: null,
      showDelete: false,
      modalDeleteItem: null,
      principalRepresenterId: null,
    }
  },
  computed: {
    canAddPrincipal() {
      return !this.subMandate && this.formData.status != InJournalStatus.ATSTOVAI_PATVIRTINTI;
    },
    canAddRepresentitive() {
      return !this.subMandate
    },
    canAddSubRepresentitive() {
      return this.subMandate
    },
    getDeletedItems(){
      let delArray = []
      if(!this.formData.parent){
        return delArray
      }
      if (this.formData.parent?.parent_id) {
        this.formData.parent.sub_representitives.map(item => {
        if (item.is_active) {
          const index = this.formData.principals.findIndex(e => e.amn_id === item.amn_id);
          if (index == -1) {
            delArray.push(item)
          }
        }
      })
      } else {
        this.formData.parent.representitives.map(item => {
        if (item.is_active) {
          const index = this.formData.principals.findIndex(e => e.amn_id === item.amn_id);
          if (index == -1) {
            delArray.push(item)
          }
        }
      })
      }
      return delArray
    },
    showDeletedItemList(){
      return this.getDeletedItems.length > 0
    },
    lockPrincipalsTogether(){
      if (this.formData.status == InJournalStatus.ATSTOVAI_PATVIRTINTI) {
        return true
      }
      if(this.subMandate){
        if (this.formData.parent?.parent_id) {
          return this.formData.parent?.sub_representitives_together || false
        }

        return this.formData.parent?.representitives_together || false
      } else {
        return false
      }
    },
    togetherList() {
      return [
        { label: 'Veikimas kartu', value: true },
        { label: 'Veikimas atskirai', value: false },
      ]
    },
    showAddPersonPrincipalsBtn() {
      return (
        this.formData.status != InJournalStatus.ATSTOVAI_PATVIRTINTI && this.formData.status != InJournalStatus.LAUKIA_PATVIRTINIMO &&
        this.formData.principals &&
        this.formData.principals.filter(
          (item) => item.amn_id === this.formData.data_provider.amn_id
        ).length == 0
      ) 
    },
     showAddPersonRepresentitivesBtn() {
      return (
        this.formData.representitives &&
        this.formData.representitives.filter(
          (item) => item.amn_id === this.formData.data_provider.amn_id
        ).length == 0
      )
    },
    documentDataList() {
      switch (this.formData.data_provider?.type) {
        case 'FIZ':
          if (this.formData.data_provider?.code) {
            return [
              {
                title: 'Vardas',
                value: this.formData.data_provider?.name || '',
                tooltip: "IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Vardas"
              },
              {
                title: 'Pavardė',
                value: this.formData.data_provider?.lastname || '',
                tooltip: "IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Pavardė"
              },
              {
                title: 'Asmens kodas',
                value: this.formData.data_provider?.code || '',
                tooltip: "IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Asmens kodas"
              },
            ]
          } else {
            return [
              {
                title: 'Vardas',
                value: this.formData.data_provider?.name || '',
              },
              {
                title: 'Pavardė',
                value: this.formData.data_provider?.lastname || '',
              },
              {
                title: 'ILTU kodas',
                value: this.formData.data_provider?.iltu_code || '',
                hide: !this.formData.data_provider?.iltu_code
              },
              // {
              //   title: 'Gimimo data',
              //   value: this.formData.data_provider?.birth_date || '',
              // },
              // {
              //   title: 'Šalis',
              //   value: this.formData.data_provider?.country_name || '',
              // },
            ]
          }
        case 'JUR':
          return [
            {
              title: 'Juridinio asmens pavadinimas',
              value: this.formData.data_provider?.fullname || '',
              tooltip: "IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Juridinio asmens pavadinimas"
            },
            {
              title: 'Juridinio asmens kodas',
              value: this.formData.data_provider?.code || '',
              tooltip: "IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Juridinio asmens kodas"
            },
            {
              title: 'Atstovo vardas, pavardė',
              value: this.formData.data_provider.representitive_fullname || '',
              tooltip: "IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Atstovo vardas pavardė"
            },
            {
              title: 'Atstovo asmens/ILTU kodas',
              value: this.formData.data_provider.representitive_code || '',
              tooltip: "IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Atstovo asmens kodas"
            },
          ]
        case 'UZS':
          return [
            {
              title: 'ILTU kodas',
              value: this.formData.data_provider?.code || '',
            },
            {
              title: 'Vardas',
              value: this.formData.data_provider?.name || '',
            },
            {
              title: 'Pavardė',
              value: this.formData.data_provider?.lastname || '',
            },
            {
              title: 'Gimimo data',
              value: this.formData.data_provider?.birth_date || '',
            },
            {
              title: 'Šalis',
              value: this.formData.data_provider?.country || '',
            },
          ]
        default:
          return []
      }
    },
    getModalDeleteCode() {
      return this.modalDeleteItem &&
        this.modalDeleteItem.type === 'representitives'
        ? '000031'
        : ''
    },
    showOperationPrincipalsType() {
      return this.formData.principals?.length > 1
    },
    showOperationRepresentitivesType() {
      return this.formData.representitives?.length > 1
    },
    showOperationSubRepresentitivesType() {
      return this.formData.sub_representitives?.length > 1
    },
    showRepresentitivesTable() {
      return (
        this.formData.representitives &&
        this.formData.representitives.length > 0
      )
    },
    showSubRepresentitivesTable() {
      return (
        this.formData.sub_representitives &&
        this.formData.sub_representitives.length > 0
      )
    },
    checkJurRepresenters(){
      let logic = false
      if(this.formData.principals){
        this.formData.principals.map(item =>{
        if(item.jur_representers && item.jur_representers.length > 1){
          return true
        }
      })
      }
      return logic
    },
    showPrincipalsTableText() {
      return (
        (this.formData.principals && this.formData.principals.length > 1) || this.checkJurRepresenters
      )
    },
    showPrincipalsTable() {
      return (
        (this.formData.principals && this.formData.principals.length > 0) ||
        this.subMandate
      )
    },
    getId() {
      return this.$route.params.id || null
    },
    subMandate() {
      return this.$route.name === 'subMandateSteps' || false
    },
    modeReadonly() {
      return false
    },
    headersPrincipals() {
      let headers = [
         {
          text: '',
          align: 'start',
          value: 'index',
          sortable: false,
        },
        {
          text: this.$t('Asmens/ILTU kodas'),
          align: 'start',
          value: 'code',
        },
        {
          text: this.$t('Vardas pavardė / Pavadinimas'),
          align: 'start',
          value: 'fullname',
          width: '18rem'
        },
        {
          text: this.$t('Kita informacija'),
          align: 'start',
          value: 'other_info',
        },
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ]
      return headers
    },
    headers() {
      let headers = [
          {
          text: '',
          align: 'start',
          value: 'index_number',
          sortable: false,
        },
        {
          text: this.$t('Asmens/ILTU kodas'),
          align: 'start',
          value: 'code',
        },
        {
          text: this.$t('Vardas pavardė / Pavadinimas'),
          align: 'start',
          value: 'fullname',
          width: '18rem'
        },
        {
          text: this.$t('Kita informacija'),
          align: 'start',
          value: 'other_info',
        },
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ]
      return headers
    },
  },
  created() {
    this.getClassifiers()
    this.getData()
  },
  methods: {
    addServiceSubMandate(item){
      this.loading = true
      let formData = item
      formData.dataType =   'principals'
      let url = `persons/getByAsmCode`
      let personData = {}
      this.$axios
        .post(url, formData)
        .then((res) => {
          personData = res.data.person
          personData.modalType = 'principals'
          this.checkPerson(personData)
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.loading = false
        })
        .finally(() => {})
    },
    setSubMandateDeletedParams(item){
      item.canDelete = false
      item.canAddCustom = true
      return item
    },
    formatedIndex(index, subIndex){
      if(subIndex != undefined){
        this.formData.principals[index].jur_representers[subIndex].order_no = subIndex + 1
        return `${index + 1}.${subIndex + 1}.`
      }
      this.formData.principals[index].order_no = index + 1
      return `${index + 1}.`
    },
     formatedRepresentitivesIndex(index){
      this.formData.representitives[index].order_no = index + 1
      return `${index + 1}.`
    },
     formatedSubRepresentitivesIndex(index){
      this.formData.sub_representitives[index].order_no = index + 1
      return `${index + 1}.`
    },
    getClassifiers() {
      this.enumsClassifiers = Enums
    },
    setEditPrincipals(item) {
      this.$set(item, 'addJurRepresenter', false)
      item.canDelete = (!this.subMandate || (this.subMandate && !this.formData.principals_together)) && (this.formData.status != InJournalStatus.ATSTOVAI_PATVIRTINTI && ((this.formData.status == InJournalStatus.LAUKIA_PATVIRTINIMO && item.order_no != 1) || this.formData.status != InJournalStatus.LAUKIA_PATVIRTINIMO))
      return item
    },
    setEdit(item, type) {
      if ((type === 'principals' || type === 'jur_representers') && this.subMandate) {
        item.canDelete = this.formData.status != InJournalStatus.ATSTOVAI_PATVIRTINTI
        return item
      }
      item.canDelete = true
      return item
    },
    setRepresentitivesParams(item, type, index){
      if ((type === 'principals' || type === 'jur_representers') && this.subMandate) {
        item.canDelete = this.formData.status != InJournalStatus.ATSTOVAI_PATVIRTINTI
        return item
      }
      this.formatedRepresentitivesIndex(index) 
      item.canDelete = true
      return item
    },
    newSubRepresentative() {
      this.modalType = 'sub_representitives'
      this.showAddPerson = true
    },
    newPrincipal() {
      this.modalType = 'principals'
      this.showAddPerson = true
    },
    newJurRepresenter(item) {
      this.modalType = 'jur_representers'
      this.showAddPerson = true
      this.principalRepresenterId = item.amn_id
    },
    newRepresentative() {
      this.modalType = 'representitives'
      this.showAddPerson = true
    },
    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      if(item.type == 'jur_representers') {
         const index = this.formData.principals.findIndex(
        (formItem) => formItem.amn_id === item.mainItem.amn_id
        )
        const representersIndex = this.formData.principals[index].jur_representers.findIndex(
        (formItem) => formItem.amn_id === item.representer.amn_id
        )
        if (representersIndex > -1) {
           this.formData.principals[index].jur_representers.splice(representersIndex, 1)
        }
      } else {
        const index = this.formData[item.type].findIndex(
        (formItem) => formItem.amn_id === item.item.amn_id
        )
        if (index > -1) {
          this.formData[item.type].splice(index, 1)
        }
      }
      this.showDelete = false
    },
    addPerson(item) {
      if (item.modalType === 'principals') {
        item.canDelete = this.formData.status != InJournalStatus.ATSTOVAI_PATVIRTINTI
        // add jur_representers
        item.jur_representers = item.signing_persons
        this.formData.principals.push(item)
      } else if (item.modalType === 'representitives') {
        this.formData.representitives.push(item)
      } else if (item.modalType === 'jur_representers') {
        const index = this.formData.principals.findIndex(
          (principal) => principal.amn_id === this.principalRepresenterId
        )
        if(typeof this.formData.principals[index].jur_representers == 'undefined'){
          this.formData.principals[index].jur_representers = []
        }
        // 
        let exist = this.formData.principals[index].jur_representers.filter(
          (representer) => representer.amn_id === item.amn_id
        ).length
        if (exist) {
          return this.$root.$emit('DATA_ERROR_CODE', '000026')
        }
        // 

        this.formData.principals[index].jur_representers.push(item)
      }
      else {
        this.formData.sub_representitives.push(item)
      }
      this.showAddPerson = false
      this.loading = false
    },
    next() {
      if (this.formData.status == InJournalStatus.ATSTOVAI_PATVIRTINTI) {
        this.$emit('gotoStep', { step: '3', id: this.getId })
      } else {
        this.saveData()
      }
    },
    back() {
      if (this.formData.status == InJournalStatus.ATSTOVAI_PATVIRTINTI) {
        this.$emit('gotoStep', { step: '1', id: this.getId })
      } else {
        // this.goToRoute()
        this.$emit('gotoStep', { step: '1', id: this.getId })
      }
    },
    getData() {
      if (this.getId) {
        this.pageloading = true

        this.$axios
          .get(`in-journals/${this.getId}`)
          .then((res) => {
            this.formData = res.data.inJournal

            if (!this.formData.data_provider) {
              this.formData.data_provider = {}
            }

            if (!this.formData.data_provider_representitive) {
              this.formData.data_provider_representitive = {}
            }

            this.initialForm()

            if([803,804,807,808,810,811,812,813,815,816].includes(this.formData.status)){
              this.$router.push({ name: 'savDocuments' })
            }
          })
          .catch((err) => {
            if(err.response.status === 404){
              return this.$router.push({ name: 'sav404' })
            } else {
              this.$root.$emit('DATA_ERROR', err.response.data.message)
            }
          })
          .finally(() => {
            this.pageloading = false
          })
      }
    },
    saveData(toRoute) {
      this.$validator.validateAll().then((res) => {
        if (!this.subMandate && this.formData.representitives.length === 0 && !toRoute) {
          return this.$root.$emit('DATA_ERROR_CODE', '000032')
        }
        if ( this.formData.principals.length === 0 && !toRoute) {
          return this.$root.$emit('DATA_ERROR_CODE', '000097')
        }
        if (this.subMandate && this.formData.sub_representitives.length === 0 && !toRoute) {
          return this.$root.$emit('DATA_ERROR_CODE', '000098')
        }
        if (res) {
          this.loading = true
          let formData = this.formData
          if(toRoute){
            formData.button  = 'back'
          } else {
            formData.button  = 'next'
          }
          // if (this.formData.status != InJournalStatus.ATSTOVAI_PATVIRTINTI) {
            let url = `in-journals/${this.getId}/mandate-persons`
            this.$axios
              .post(url, formData)
              .then((res) => {
                this.$root.$emit('DATA_OK_STEP')
                // then
                this.initialForm()
                if (toRoute) {
                  this.goToRoute()
                } else {
                  this.$emit('gotoStep', { step: '3', id: this.getId })
                }
              })
              .catch((err) => {
                this.$root.$emit('DATA_ERROR', err)
              })
              .finally(() => {
                this.loading = false
              })
          // } else {
          //    this.$emit('gotoStep', { step: '3', id: this.getId })
          // }
        } else {
          this.$root.$emit('FORMAT_ERROR_STEP')
        }
      })
    },
    AddPersonRepresenter(item){
      let code = this.formData.data_provider.representitive_code
      let fullname = this.formData.data_provider.representitive_fullname
      let formData = {}
      formData.code = code
      formData.name = fullname.split(' ')[0]
      formData.lastname = fullname.split(' ')[1]
      formData.type = "FIZ"
      formData.dataType = 'jur_representers'
      let url = `persons/getByAsmCode`
      this.$axios
        .post(url, formData)
        .then((res) => {
          let personData = res.data.person
          personData.type = "FIZ"
          personData.modalType = 'jur_representers'
          this.principalRepresenterId = item.amn_id
          this.addPerson(personData)
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    checkPerson(personData) {
      // this.loading = true
      let code = personData.code
      let type = personData.type
      let dataType = personData.modalType
      const isSavitarna = window.location.host === process.env.VUE_APP_SAVITARNA_HOST
      this.$axios
        .post('persons/checkPerson', { code: code, type: type, dataType: dataType, isSavitarna: isSavitarna })
        .then(() => {
          this.addPerson(personData)
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.loading = false
        })
        .finally(() => {
          // this.loading = false
        })
    },
    rowClass() {
        return `row-red`
    },
    AddPersonBtn(representitives) {
      this.loading = true
      let formData = this.formData.data_provider
      formData.dataType =  representitives ? 'representitives' : 'principals'
      let url = ''
      if(formData.code) {
        url = `persons/getByAsmCode`
      } else {
        url = `persons/getForeignerByBirthDate`
      }
      let personData = {}
      this.$axios
        .post(url, formData)
        .then((res) => {
          personData = res.data.person
          personData.type = this.formData.data_provider.type
          personData.modalType = representitives ? 'representitives' : 'principals'
          this.checkPerson(personData)
         
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.loading = false
        })
        .finally(() => {})
    },
  },
}
</script>
<style lang="scss" scoped></style>